export default __webpack_public_path__ + "static/media/d5c7c25d312454851df0d95979feb7f6d73a413386cf5dda4a28b5be1d859740.4cee1acf.png";